<template>
  <svg
    width="59"
    height="58"
    viewBox="0 0 59 58"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >

    <path
      :class="active ? 'a-active' : 'a'"
      d="M29.5006 30.5259H17.29"
      stroke="#142B6F"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      :class="active ? 'a-active' : 'a'"
      d="M37.1321 22.8945H17.29"
      stroke="#142B6F"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      :class="active ? 'a-active' : 'a'"
      d="M37.1321 38.1577H17.29"
      stroke="#142B6F"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      :class="active ? 'a-active' : 'a'"
      d="M41.7106 30.5259H32.5527"
      stroke="#142B6F"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <circle
      :class="active ? 'a-active' : 'a'"
      cx="29.5"
      cy="29"
      r="28.5"
      stroke="#142B6F"
    />
  </svg>
</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.a {
  stroke: #CDD1DE;
  stroke-width: 1px;
}

.a-active {
}
</style>
